import React, { useCallback } from 'react'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { isContractFormEditable, setIsEditable } from './redux'
import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { Trans, useTranslation } from 'translations'

export const ContractEditWarning: React.FC = () => {
    const { t } = useTranslation()
    const dispatch = useAppDispatch()
    const isEditable = useAppSelector(isContractFormEditable)
    const shouldShowContractPageWarning = location.pathname.includes('contract')

    const toggleEditable = useCallback(() => {
        dispatch(setIsEditable(true))
    }, [dispatch, setIsEditable])

    if (!shouldShowContractPageWarning) {
        return null
    }

    return (
        <Box my="2rem" maxWidth="80%">
            <Alert
                severity="warning"
                action={
                    !isEditable && (
                        <Button size="small" variant="text" onClick={toggleEditable}>
                            {t('settings.accountSettings.contract.editWarning.editButton')}
                        </Button>
                    )
                }
            >
                <Trans
                    i18nKey="settings.accountSettings.contract.editWarning.message"
                    components={{ strong: <strong /> }}
                />
            </Alert>
        </Box>
    )
}
